import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { getEmployeeAmountSegments } from '@bca-company-data/company-data.constants';

@Component({
  selector: 'bca-company-employees',
  templateUrl: 'company-employees.component.html',
  styleUrls: ['company-employees.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyEmployeesComponent implements OnInit {
  @Input()
  employeeAmount: number;
  @Input()
  employeeRequiredError: boolean;

  @Output()
  selected = new EventEmitter<number>();

  segments = getEmployeeAmountSegments();

  ngOnInit(): void {
    const { employeeAmount, selected } = this;
    selected.emit(employeeAmount);
  }

}
